import React from 'react';
import { Form } from 'react-bootstrap';

const OPTIONS = [
  { value: '01', label: 'Op. tributável — BC = valor operação' },
  { value: '02', label: 'Op. tributável — BC = valor operação (alíq. dif.)' },
  { value: '03', label: 'Op. tributável — BC = qtde (alíq. por unidade)' },
  { value: '04', label: 'Op. tributável — monofásica (alíquota zero)' },
  { value: '05', label: 'Op. tributável — ST' },
  { value: '06', label: 'Op. tributável — alíquota zero' },
  { value: '07', label: 'Op. isenta' },
  { value: '08', label: 'Op. sem incidência' },
  { value: '09', label: 'Op. c/ suspensão' },
  { value: '49', label: 'Outras entradas' },
  { value: '50', label: 'Op. c/ direito a crédito — BC = valor operação' },
  { value: '70', label: 'Op. de aquisição c/ redução' },
  { value: '75', label: 'Op. de aquisição c/ alíquota zero' },
  { value: '98', label: 'Outras operações de entrada' },
  { value: '99', label: 'Outras operações' },
];

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  size?: 'sm' | 'lg';
  isInvalid?: boolean;
}

const SelectCSTContribuicao = React.forwardRef<HTMLSelectElement, Props & Omit<React.ComponentPropsWithoutRef<'select'>, 'onChange' | 'value' | 'size'>>(
  ({ value, onChange, disabled, size, isInvalid, ...rest }, ref) => (
    <Form.Select
      ref={ref}
      size={size}
      value={value ?? ''}
      onChange={e => onChange?.(e.target.value)}
      disabled={disabled}
      isInvalid={isInvalid}
      aria-label="CST PIS/COFINS"
      {...rest}
    >
      <option value="">CST...</option>
      {OPTIONS.map(o => (
        <option key={o.value} value={o.value}>{o.value} — {o.label}</option>
      ))}
    </Form.Select>
  )
);

SelectCSTContribuicao.displayName = 'SelectCSTContribuicao';

export default SelectCSTContribuicao;
